
































































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import { finalize } from 'rxjs/operators'
import { translate } from '@/utils/filters'
import $Api from '@api'
import { RepaymentPageRecord, CalculationExtendsResponse, CalculationExtendsRequest } from '@/api/model/repayment'
import * as JMath from '@/utils/math'

@Component
export default class ExtendsFormComponent extends Vue {
    @Prop() private msg!: string

    @Prop() visible!: boolean

    disabled = true
    calculateData: any = []
    unpaidData: CalculationExtendsResponse[] = []

    defaultCalculateData = {
        inputAmount: 0,
        calcAmount: 0,
        capitalAmount: 0,
        interestAmount: 0,
        penaltyAmount: 0,
        feesAmount: 0
    }

    @Emit('close')
    handleClose(): void {}

    @Emit('refresh')
    handleRefresh(): void {}

    fetchData({ lid, indexs, ...rest }: RepaymentPageRecord): void {
        this.calculateData = [{ lid, indexs, ...this.defaultCalculateData }]
        this.disabled = true
        const params: CalculationExtendsRequest = {
            lid,
            indexs
        }

        $Api.repaymentService.calculationExtends(params).subscribe(
            data => {
                this.unpaidData = [data]
                if (data.extendsFee === 0) {
                    this.disabled = false
                }
            },
            error => {
                Message.error(error.message)
            }
        )
    }

    onManualSubmit(): void {
        const [calculateItem] = this.calculateData
        const lid = calculateItem.lid
        const indexs = calculateItem.indexs

        const params: CalculationExtendsRequest = {
            lid,
            indexs
        }

        $Api.repaymentService.repaymentExtends(params).subscribe(
            data => {
                Message.success(translate('repayment.unpaid.extendsDialog.onExtendsPaidSubmit.success') as string)
                this.handleClose()
                this.handleRefresh()
            },
            error => {
                Message.error(error.message)
            }
        )
    }
}
